<template>
    <div ref="scroller" class="asset-list-scrollable" @scroll="handleScroll">
        <AssetList
            ref="list"
            :list="list" 
            :file="file" 
            :context="context" 
            :scaling="scaling" 
            :overflow="overflow"
            :selectable="selectable" 
            :persist="persist"
            :multiple="multiple" 
            :max-assets="maxAssets" 
            :limit="true" 
            @select="handleSelect" />
    </div>

    <TransitionFadeY>
        <FloatingButton
            v-if="isScrolled" 
            style="padding-left: 0px !important; padding-right: 0px !important;"
            justify="right"
            tooltip="go back to the top"
            @click="handleUnscroll">
            <v-icon icon="fa-solid fa-caret-up"></v-icon>
        </FloatingButton>
    </TransitionFadeY>
</template>

<script>
import ASSETS from '@generio-ai/library-legacy/constants/assets'
import { TransitionFadeY } from '@generio-ai/library-legacy/components/transitions'
import AssetList from '@/components/common/asset/AssetList.vue'
import FloatingButton from '@/components/common/button/FloatingButton.vue'

export default {
    name: 'AssetListScrollable',
    components: {
        TransitionFadeY,
        AssetList,
        FloatingButton
    },
    props: {
        // list of assets
        list: {
            type: Array,
            default: null
        },

        // file key 
        file: {
            type: String,
            default: ASSETS.FILES.KEY.DEFAULT
        },

        // if true, context menu is available
        context: {
            type: Boolean,
            default: false  
        },

        // allows to adjust the scaling of the asset item
        scaling: {
            type: Number,
            default: 1.0
        },

        // if true, item is allowed to overflow border on hover
        overflow: {
            type: Boolean,
            default: false
        },

        // if true, select event is triggered on item click
        selectable: {
            type: Boolean,
            default: true
        },

        // if true, track selected items
        persist: {
            type: Boolean,
            default: false
        },

        // if true, multiple selection is allowed (only useful with selectable)
        multiple: {
            type: Boolean,
            default: false
        },

        maxAssets: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            isScrolled: false
        }
    },
    emits: ['select'],
    methods: {
        handleSelect(asset, selected) {
            this.$emit('select', asset, selected)
        },
        handleScroll() {
            const scroller = this.$refs.scroller
            if (scroller === undefined || scroller === null) return

            // extract relevant details
            const scrollPosition = scroller.scrollTop
            const contentHeight = scroller.scrollHeight
            const visibleHeight = scroller.clientHeight

            // if we've scrolled close to the bottom
            if (scrollPosition + visibleHeight >= contentHeight - 200) {
                this.$refs.list?.addRow()
            }

            // toggle isScrolled if we've scrolled > 100px
            this.isScrolled = scrollPosition > 100
        },
        handleUnscroll() {
            this.$refs.scroller.scroll({
                top: 0,
                behavior: 'smooth'
            })
            this.isScrolled = false
        }
    }
}
</script>

<style scoped>
.asset-list-scrollable {
    display: block;
    width: 100%;
    height: 100%;
    overflow-y: auto;
}
</style>